import React, { useCallback, useEffect, useRef, useState, useTransition } from "react";
import Card from "react-bootstrap/Card";
import SingleRangeSlider from "@core/component/SingleSlider/SingleRangeSlider";
import LoaderImg from "@assets/images/loader.gif";
import { getApiUrl } from "@utils/baseUrl";
import axios from "axios";
import { toast } from "react-toastify";
import commaFormat from "@utils/commaFormat";
import { Modal } from "react-bootstrap";
import { useDebounce } from "@utils/utils";
import { useDispatch, useSelector } from "react-redux";
import { selectedFilterListHandler } from "@redux/Shipment/shipmentSlice";
import ViewAllFilter from "./viewAll-filter";

const LIMIT = 50;
const FETCH_THRESHOLD = 30;
const apiEndpoints = {
  proximitySearch: getApiUrl("proximitySearch"),
};
const ProximityViewAll = ({ proximityFilterDetails, noDataFound, setNoDataFound, setSearchedData, onApply, closeFilter, filterList, filterKeyword, appliedFilterList, filterDetails, searchReqObj, tradeDirection, countryCode, hasMore, loader, searchedData, getFilterDataHandler, proximityClicked }) => {
  const [isPending, startTransition] = useTransition();
  const [isProximity, setIsProximity] = useState(false);
  const [isDefaultScreen, setIsDefaultScreen] = useState(true);
  const [searchedZipcode, setSearchedZipcode] = useState("");
  const [zipcodeValidate, setZipcodeValidate] = useState(false);
  const [zipcodeResult, setZipcodeResult] = useState([]);
  const [searchLoader, setSearchLoader] = useState(false);
  const [zipcodeShowCount, setZipcodeShowCount] = useState(10);
  const [selectedList, setSelectedList] = useState({});
  const [selectedProximityList, setselectedProximityList] = useState({});
  const [radius, setRadius] = useState(5);
  const [proximitySearchedData, setProximitySearchData] = useState({});
  const [payloadRadius, setPayloadRadius] = useState();
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [inputValue, setInputValue] = useState(null);
  const [cachedData, setCachedData] = useState([]);
  const [isLoaderActive, setIsLoaderActive] = useState(false);
  const observer = useRef();
  const [displayedItems, setDisplayedItems] = useState(LIMIT);
  const debouncedInputValue = useDebounce(inputValue, 500);
  const appliedFilterListNew = useSelector((state) => state.shipmentDetails.selectedFilterList);
  const filterLoader = useSelector((state) => state.shipmentDetails.filterLoader);
  const mustNot = useSelector((state) => state.shipmentDetails.filterMustNot);
  const [filterListDocCount, setFilterListDocCount] = useState({});
  const [filterListClone, setFilterListClone] = useState([]);
  const [selectedFilterIds, setSelectedFilterIds] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const dispatch = useDispatch();
  const inputRef = useRef(null);
  useEffect(() => {
    if (mustNot?.length <= 1000) {
      initializeFilterData();
    } else {
      const selectedDataList = searchedData?.length > 0 || inputValue?.length > 0 ? searchedData : filterList;
      const tempDocCount = filterListDocCount;
      selectedDataList.forEach((item) => (tempDocCount[item.key] = item.doc_count));
      setFilterListDocCount(tempDocCount);
      setCachedData(selectedDataList);
    }
  }, [filterList, mustNot, searchedData]);
  useEffect(() => {
    if (proximityFilterDetails?.selectedZipcode && Array.isArray(proximityFilterDetails?.selectedZipcode) && proximityClicked) {
      let temp = {};
      proximityFilterDetails?.selectedZipcode.forEach((item) => {
        temp[item] = true;
      });
      setIsProximity(true);
      setIsDefaultScreen(false);
      if (proximityFilterDetails?.appliedRadius) setRadius(proximityFilterDetails?.appliedRadius);
      if (proximityFilterDetails?.appliedRadius) setPayloadRadius(proximityFilterDetails?.appliedRadius);
      if (proximityFilterDetails?.zipcodeList) setZipcodeResult([...(proximityFilterDetails?.zipcodeList ?? [])]);
      if (proximityFilterDetails?.searchedZipcode) setSearchedZipcode(proximityFilterDetails?.searchedZipcode);
      setselectedProximityList(JSON.parse(JSON.stringify(temp)));
    } else {
      setSelectedFilterIds([...appliedFilterList]);
      setSelectedList(appliedFilterListNew?.[filterDetails.key] ?? []);
    }
  }, [appliedFilterList, proximityFilterDetails]);
  useEffect(() => {
    setNoDataFound(false);
    setSearchedData([]);
    handleSearch(debouncedInputValue);
  }, [debouncedInputValue]);

  useEffect(() => {
    setNoDataFound(false);
  }, []);

  const handleSearch = (text) => {
    setIsLoaderActive(true);
    if (text || text === "") {
      setFilterData([]);
      getFilterDataHandler(filterDetails, undefined, text);
      setDisplayedItems(LIMIT);
    }
    setIsLoaderActive(false);
  };

  const handleOnSelect = (isChecked, data) => {
    const newSelectedIds = new Set(selectedFilterIds);
    const newSelectedFilterList = JSON.parse(JSON.stringify(selectedList));
    if (isChecked) {
      newSelectedIds.add(data.key);
      newSelectedFilterList[data.key] = data;
    } else {
      newSelectedIds.delete(data.key);
      delete newSelectedFilterList[data.key];
    }
    setFiltersStateHandler(newSelectedIds);
    setSelectedFilterIds([...newSelectedIds]);
    setSelectedList({ ...newSelectedFilterList });
  };
  const setFiltersStateHandler = (selectedFilterIds) => {
    startTransition(() => {
      const updatedFilterListClone = filterListClone.map((item) => ({
        ...item,
        isChecked: selectedFilterIds.has(item.key),
      }));
      setFilterListClone(updatedFilterListClone);
    });
  };
  const sortSearchResults = (results) => {
    const selectedSet = new Set(selectedFilterIds);
    let uniqueResults = [];
    if (inputValue !== "" && inputValue !== null) {
      uniqueResults = results.sort((a, b) => {
        return selectedSet.has(b.key) - selectedSet.has(a.key);
      });
    } else {
      results = [...results.filter((item) => !selectedList[item.key])];
      uniqueResults = [...new Set([...Object.values(selectedList), ...results])].sort((a, b) => {
        return selectedSet.has(b.key) - selectedSet.has(a.key);
      });
    }
    return uniqueResults;
  };
  const initializeFilterData = () => {
    setIsLoaderActive(true);
    const selectedDataList = searchedData?.length > 0 || inputValue?.length > 0 ? searchedData : filterList;
    const tempDocCount = filterListDocCount;
    selectedDataList.forEach((item) => (tempDocCount[item.key] = item.doc_count));
    setFilterListDocCount(tempDocCount);
    const searchedResultArr = selectedDataList.filter((item) => (item.description && item.description) || (item.key && item.key.toLowerCase()));
    const sortedSearchedResultArr = sortSearchResults(searchedResultArr);
    setFilterData([...sortedSearchedResultArr.slice(0, LIMIT)]);
    setFilterListClone(sortedSearchedResultArr ? sortedSearchedResultArr.slice(0, LIMIT) : []);
    setCachedData(sortedSearchedResultArr || []);
    setIsLoaderActive(false);
  };
  const handleZipcodeChange = (zipcode) => {
    setSearchedZipcode(zipcode);
  };
  const zipcodeSearch = () => {
    if (/^\d+$/.test(searchedZipcode) && searchedZipcode.length === 5) {
      callProximityApi();
    } else {
      setZipcodeValidate(true);
      setTimeout(() => {
        setZipcodeValidate(false);
      }, 3000);
    }
  };
  const handleLoadMore = () => {
    setZipcodeShowCount(zipcodeShowCount + 10);
    setTimeout(() => {
      let divElement = document.getElementById("proximity-zipcode-box");
      divElement.scroll({
        top: divElement.scrollHeight, //scroll to the bottom of the element
        behavior: "smooth", //auto, smooth, initial, inherit
      });
    }, 200);
  };
  const handleRadiusChange = (e) => {
    setRadius(e);
    if (e > 0) {
      if (e > 500) {
        setRadius(500);
      } else setRadius(e);
    } else setRadius("");
  };
  const zipcodeSelect = (isChecked, key) => {
    let tempObj = { ...selectedProximityList };
    if (!key) {
      if (isChecked) {
        for (let i = 0; i < zipcodeResult.length; i++) {
          if (!tempObj[zipcodeResult[i].zip_code]) {
            tempObj[zipcodeResult[i].zip_code] = true;
          }
        }
      } else if (!isChecked) {
        tempObj = {};
      }
    } else {
      if (isChecked && !tempObj[key]) {
        tempObj[key] = true;
      } else if (!isChecked && tempObj[key]) {
        delete tempObj[key];
      }
    }
    setselectedProximityList({ ...tempObj });
  };
  const callProximityApi = () => {
    if (radius === "") {
      setRadius(5);
    }
    let tempObj = { ...proximitySearchedData };
    tempObj.appliedRadius = radius;
    tempObj.searchedZipcode = searchedZipcode;
    tempObj.zipcodeList = [];
    tempObj.selectedZipcode = [];
    setProximitySearchData(tempObj);
    setIsDefaultScreen(false);
    setSearchLoader(true);
    setZipcodeShowCount(10);
    setPayloadRadius(radius);
    setZipcodeResult([]);
    let reqObj = searchReqObj;
    reqObj.zipCode = searchedZipcode;
    reqObj.tradeDirection = !!tradeDirection && tradeDirection !== "" ? tradeDirection : "I";
    reqObj.country = !!countryCode && countryCode !== "" ? countryCode : "US";
    reqObj.distance = !!radius && radius !== "" ? radius : 5;
    axios
      .post(apiEndpoints.proximitySearch, reqObj)
      .then((res) => {
        if (!!res && !!res.data && !!res.data.zip_codes && res.data.zip_codes.length > 0) {
          let tempArr = [];
          for (const item of res.data.zip_codes) {
            item.isChecked = false;
            tempArr.push(item);
          }
          let tempObj = { ...proximitySearchedData };
          tempObj.appliedRadius = radius;
          tempObj.searchedZipcode = searchedZipcode;
          tempObj.selectedZipcode = [];
          tempObj.zipcodeList = tempArr;
          setProximitySearchData(tempObj);
          setZipcodeResult(tempArr);
          setSearchLoader(false);
        } else {
          setSearchLoader(false);
        }
      })
      .catch(() => {
        setSearchLoader(false);
        toast.error("Something went wrong. Please try again later!!!");
      });
  };
  const switchProximity = (e) => {
    setIsProximity(e);
  };

  const handleApply = () => {
    closeFilter();
    if (!isProximity) {
      let tempData = JSON.parse(JSON.stringify(filterList));
      let tempAppliedSelectedList = JSON.parse(JSON.stringify(appliedFilterListNew));
      tempAppliedSelectedList[filterDetails.key] = selectedList;
      dispatch(selectedFilterListHandler(tempAppliedSelectedList));
      for (let i = 0; i < tempData.length; i++) {
        if (selectedList[tempData[i].key]) {
          tempData[i].isChecked = true;
        }
      }
      onApply(false, tempData, Object.keys(selectedList));
    } else {
      let tempData = JSON.parse(JSON.stringify(zipcodeResult));
      let tempAppliedSelectedList = JSON.parse(JSON.stringify(appliedFilterListNew));
      tempAppliedSelectedList[filterDetails.key] = selectedProximityList;
      dispatch(selectedFilterListHandler(tempAppliedSelectedList));
      for (let i = 0; i < tempData.length; i++) {
        if (selectedProximityList[tempData[i].key]) {
          tempData[i].isChecked = true;
        }
      }
      onApply(true, tempData, Object.keys(selectedProximityList), payloadRadius, zipcodeResult, searchedZipcode);
    }
  };

  const loadMore = useCallback(() => {
    startTransition(() => {
      const newDisplayedItems = displayedItems + LIMIT;
      setDisplayedItems(newDisplayedItems);
      setFilterData(cachedData.slice(0, newDisplayedItems));
      setFilterListClone(cachedData.slice(0, newDisplayedItems));

      if (newDisplayedItems + FETCH_THRESHOLD >= cachedData.length && hasMore) {
        getFilterDataHandler(filterDetails, mustNot, inputValue);
      }
    });
  }, [displayedItems, cachedData, hasMore, inputValue]);

  const lastElementRef = useCallback(
    (node) => {
      if (loader) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && cachedData.length > displayedItems) {
          loadMore();
        }
      });
      if (node) observer.current.observe(node);
    },
    [loader, loadMore, cachedData, displayedItems, inputValue]
  );

  const handleApplyClick = () => {
    if (isProximity) {
      if (selectedList && Object.keys(selectedList).length !== 0) {
        setShowConfirmationPopup(true);
      } else {
        handleApply();
      }
    } else {
      if (selectedProximityList && Object.keys(selectedProximityList).length !== 0) {
        setShowConfirmationPopup(true);
      } else {
        handleApply();
      }
    }
  };
  return (
    <>
      <Card className={showConfirmationPopup ? "view-all-filter-panel-card confirmation" : "view-all-filter-panel-card"} id="proximity-search-viewall">
        {showConfirmationPopup ? (
          <Modal.Header>
            <Modal.Title>Confirmation</Modal.Title>
          </Modal.Header>
        ) : (
          <Card.Header>
            <div className="d-flex">
              <div className="col-md-5 pl-2">
                Filter using
                <span id="proximity-switch-button" className="ml-2">
                  <button className={isProximity ? "proximity-button mr-1" : "proximity-button-active mr-1"} onClick={() => switchProximity(false)}>
                    Zipcodes
                  </button>
                  <button className={!isProximity ? "proximity-button" : "proximity-button-active"} onClick={() => switchProximity(true)}>
                    Proximity Search
                  </button>
                </span>
              </div>
              <div className="col-md-5 pl-0" />
              <div className="col-md-2 text-right pr-0">
                <button type="button" disabled={(selectedList && Object.keys(selectedList).length === 0 && !isProximity) || (isProximity && selectedProximityList && Object.keys(selectedProximityList).length === 0)} className="btn btn-primary btn-sm trademo-new-btn" onClick={handleApplyClick}>
                  Apply
                </button>
                <button type="button" className="close trademo-modal-close" aria-label="Close" onClick={() => closeFilter(filterKeyword)}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
          </Card.Header>
        )}
        {showConfirmationPopup ? (
          <Modal.Body>
            <div className="row m-0 ">This change will override the previously selected zip codes. Click on confirm to continue.</div>
          </Modal.Body>
        ) : (
          <Card.Body id="proximity-card-body">
            {isProximity && (
              <div className="d-flex" id="proximity-section">
                <div className="col-md-6" id="proximity-search-section">
                  <div id="proximity-search-box">
                    <span className="d-block">
                      <label htmlFor="zipcodeInput" className="text">
                        Type zipcode
                      </label>
                    </span>
                    <input className="form-control" type="text" placeholder="Enter a zipcode" onChange={(e) => handleZipcodeChange(e.target.value)} value={searchedZipcode} />
                    {zipcodeValidate ? <span className="font-red d-block">Please enter a valid US zip code</span> : <></>}
                  </div>
                  <div id="proximity-slider-box">
                    <div className="d-flex pt-3 pb-3">
                      <span className="col-md-6 p-0">
                        Search within <span className="text-bold">(miles)</span>
                      </span>
                      <span className="col-md-6 text-right pb-1">
                        <button className="radius-button" onClick={() => setRadius(Math.max(1, radius - 1))} disabled={radius <= 1}>
                          -
                        </button>
                        <input className="radius-display mx-1 p-1 text-center" value={radius} onChange={(e) => handleRadiusChange(e.target.value)} />
                        <button className="radius-button" onClick={() => setRadius(Math.min(500, radius + 1))} disabled={radius >= 500}>
                          +
                        </button>
                      </span>
                    </div>
                    <SingleRangeSlider
                      min={1}
                      max={500}
                      value={radius}
                      onChange={(e) => {
                        setRadius(+e.value);
                      }}
                    />
                    <div className="d-flex pt-2">
                      <span className="col-md-6 p-0 text-left text-bold">1</span>
                      <span className="col-md-6 p-0 text-right text-bold">500</span>
                    </div>
                  </div>
                  <div className="mt-4">
                    <button type="button" disabled={searchedZipcode.length < 5} className="btn btn-primary btn-sm trademo-new-btn w-100" onClick={() => zipcodeSearch()}>
                      Search Zipcodes
                    </button>
                  </div>
                </div>
                <div className="col-md-6" id="proximity-result-section">
                  {searchLoader && !noDataFound ? (
                    <div className="d-flex justify-content-center align-items-center h-100">
                      <img src={LoaderImg} alt="description of gif" />{" "}
                    </div>
                  ) : isDefaultScreen ? (
                    <></>
                  ) : zipcodeResult.length === 0 ? (
                    <div className="d-flex justify-content-center align-items-center h-100">
                      <div>
                        <span className="d-block text-center">
                          <span className="no-result-icon pt-4 mb-4">
                            <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1658434078/intel/icons/search-eye-line_iqznhd.svg" />
                          </span>
                        </span>
                        <span>No zip code found nearby. Please try again with a larger radius.</span>
                      </div>
                    </div>
                  ) : (
                    <>
                      <div id="result-display-box">
                        {zipcodeResult.length > 0 ? (
                          <span>
                            <span className="text-bold">{zipcodeResult.length}</span> zipcode(s) with non-zero shipments found in <span className="text-bold">{payloadRadius}</span> mile(s) radius
                          </span>
                        ) : (
                          <></>
                        )}
                      </div>
                      <div id="proximity-zipcode-box" className="p-2">
                        <label className="form-check">
                          <input className="form-check-input" type="checkbox" id={"prozimityselectall"} checked={Object.keys(selectedProximityList).length === zipcodeResult.length} onChange={(e) => zipcodeSelect(e.target.checked)} />
                          <span className="form-check-label">Select All </span>
                        </label>
                        {zipcodeResult.slice(0, zipcodeShowCount).map((item, i) => (
                          <label className="form-check" key={item.zip_code}>
                            <input className="form-check-input" type="checkbox" id={"prozimitysearch" + i} checked={selectedProximityList?.[item.zip_code] ?? false} onChange={(e) => zipcodeSelect(e.target.checked, item.zip_code)} />
                            <span className="form-check-label">
                              {!!item.zip_code && item.zip_code !== "" ? item.zip_code : "Not Available"}
                              <span className="grey-text"> {item.doc_count ? `(${commaFormat(item.doc_count)})` : ""}</span>
                            </span>
                          </label>
                        ))}
                        {!!zipcodeResult && zipcodeResult.length > zipcodeShowCount ? (
                          <a className="text trademo-link" onClick={() => handleLoadMore()}>
                            Load more <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1656318671/intel/dashboard%202.0/refresh-line_ny7xtg.svg" />
                          </a>
                        ) : (
                          <></>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            )}
            {!isProximity && (
              <>
                <div className="col-md-5 pl-0 mt-2 mb-4 pl-3 ">
                  <input
                    className="form-control"
                    type="text"
                    ref={inputRef}
                    value={inputValue}
                    placeholder={"Search " + filterDetails.label}
                    onChange={(e) => {
                      setInputValue(e.target.value);
                      setIsLoaderActive(true);
                    }}
                  />
                </div>
                {isLoaderActive || filterLoader ? (
                  <div className="d-flex justify-content-center align-items-center" style={{ height: "calc(100% - 146px)" }}>
                    <img src={LoaderImg} alt="Loading" />
                  </div>
                ) : filterData?.length !== 0 ? (
                  <div className="d-flex flex-wrap">
                    {filterData.map((data, i) => (
                      <React.Fragment key={i + data.key}>
                        {!!data.key && data.key !== "" && (
                          <div className="col-md-4 d-flex align-items-center">
                            <label className="form-check select_value_input">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id={data.key + i}
                                value={data.isChecked}
                                checked={selectedFilterIds.includes(data.key)}
                                onChange={(e) => {
                                  handleOnSelect(e.target.checked, data);
                                }}
                                disabled={data.isDisabled === true}
                              />
                              <span className="form-check-label">
                                {data?.key}
                                {appliedFilterList.includes(data.key) && !selectedProximityList?.[data.key] && selectedList?.[data.key] ? <span className="grey-text"> ({commaFormat(selectedList?.[data.key]?.doc_count ?? 0)})</span> : <span className="grey-text"> ({(!!data.doc_count || data.doc_count === 0) && typeof data.doc_count === "number" ? commaFormat(data.doc_count) : data.doc_count ? data.doc_count : ""})</span>}
                              </span>
                            </label>
                          </div>
                        )}
                      </React.Fragment>
                    ))}
                    <div ref={lastElementRef} className="d-flex justify-content-center align-items-center mb-2 col-md-12">
                      {isPending || (loader && <img src={LoaderImg} width={48} height={48} alt="Loading..." />)}
                    </div>
                  </div>
                ) : noDataFound ? (
                  <ViewAllFilter content={"No Data Found"} filterKeyword={filterKeyword} label={filterDetails.label} />
                ) : (
                  <div className="d-flex justify-content-center align-items-center" style={{ height: "calc(100% - 146px)" }}>
                    <img src={LoaderImg} alt="Loading" />
                  </div>
                )}
              </>
            )}
          </Card.Body>
        )}
        {showConfirmationPopup && (
          <Card.Footer>
            <div className="p-0 m-0 d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-outline-secondary trademo-outline-btn btn-sm mr-2"
                onClick={() => {
                  setShowConfirmationPopup(false);
                }}>
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary btn-sm trademo-new-btn"
                onClick={() => {
                  setShowConfirmationPopup(false);
                  handleApply();
                }}>
                Confirm
              </button>
            </div>
          </Card.Footer>
        )}
      </Card>
    </>
  );
};
export default ProximityViewAll;
